import { render } from "./RulesSection.vue?vue&type=template&id=57489173"
import script from "./RulesSection.vue?vue&type=script&lang=js"
export * from "./RulesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__